module.exports = __webpack_public_path__ + "img/henrikmainpic.597b0c78.png";